import React, { type ComponentProps, type FC } from 'react';

import LegacyAttributeList from 'pages/Product/components/AttributeList';

export type WiseAttributeListProps = ComponentProps<typeof LegacyAttributeList>;

/** Lista atrybutów (Wise) — obecnie delegacja do legacy. */
const WiseAttributeList: FC<WiseAttributeListProps> = (props) => (
  <LegacyAttributeList {...props} />
);

export default WiseAttributeList;
